<template>
  <div
    class="d-flex justify-space-between align-center"
    v-on="$listeners"
  >
    <div class="d-flex align-center">
      <researcher-avatar
        :researcher="researcher"
        :review-member-invite="reviewMemberInvite"
        small
        disable-popover
      />
      <span class="mx-2 text-subtitle-2">{{ name }}</span>
      <slot name="after-name"></slot>
    </div>
    <slot name="right"></slot>
  </div>
</template>

<script>
import ResearcherAvatar from '@/components/Common/ResearcherAvatar';
import { Researcher, ReviewMemberInvite } from '@/models';

export default {
  name: 'BaseReviewMemberListItem',
  components: { ResearcherAvatar },
  props: {
    researcher: {
      type: Researcher,
      default: null,
    },
    reviewMemberInvite: {
      type: ReviewMemberInvite,
      default: null,
    },
  },
  computed: {
    name() {
      return (
        this.researcher?.name || this.reviewMemberInvite?.emailAddress
      );
    },
  },
};
</script>
